import React from 'react'
import { Table } from '../../../../../../../components/Table'
import { TableHead } from '../../../../../../../components/Table/TableHead'
import { TableBody } from '../../../../../../../components/Table/TableBody'
import { IExternalTransaction } from '../../core/response.types'
import { convertUTCtoMSK } from '../../../../../../../utils'

interface ExternalTransactionsTableProps {
  items: IExternalTransaction[]
  isLoading: boolean
}

export const ExternalTransactionsTable: React.FC<ExternalTransactionsTableProps> = ({
  items,
  isLoading,
}) => {
  const handleRowClick = (id: number) => {
    window.open(`/logs/external-transactions/${id}`, '_blank')
  }

  return (
    <Table>
      <TableHead>
        <tr>
          <th>ID</th>
          <th>Провайдер</th>
          <th>Тикет</th>
          <th>ID адаптера</th>
          <th>Статус</th>
          <th>Создан</th>
          <th>Обновлён</th>
          <th></th>
        </tr>
      </TableHead>
      <TableBody>
        {isLoading ? (
          <tr>
            <td colSpan={8}>Идёт загрузка...</td>
          </tr>
        ) : items.length ? (
          items.map((item) => (
            <tr
              key={item.id}
              // style={{ cursor: 'pointer' }}
              // onClick={() => handleRowClick(item.id)}
            >
              <td>{item.id}</td>
              <td>{item.provider || '—'}</td>
              <td>
                <span style={{ fontFamily: 'monospace', fontSize: '0.85rem' }}>
                  {item.token || '—'}
                </span>
              </td>
              <td>{item.payment_id || '—'}</td>
              <td>
                <span className='badge badge-light-info'>{item.status || '—'}</span>
              </td>
              <td>{convertUTCtoMSK(item.created_at)}</td>
              <td>{convertUTCtoMSK(item.updated_at)}</td>
              <td>
                <button
                  type='button'
                  className='btn btn-sm btn-light-primary'
                  onClick={(e) => {
                    e.stopPropagation()
                    handleRowClick(item.id)
                  }}
                >
                  Детали
                </button>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={8}>Данных нет.</td>
          </tr>
        )}
      </TableBody>
    </Table>
  )
}
